export default {"src":"/_next/static/media/ic_skillz_mark_with_bars.c049ca19.svg","height":46,"width":126,"blurWidth":0,"blurHeight":0};